module.exports = __webpack_public_path__ + "static/img/partner.0a2ba64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/partner.png
// module id = R/0S
// module chunks = 0